import React, { useCallback, useEffect } from 'react';
import { getSearchParam } from 'helpers/getSearchParam';

import { useCasinoNewState } from '@atlas/core';
import { Button, ChipsItem, DefaultPopup } from '@atlas/ui';

import ModalPortal from 'common/ModalPortal/ModalPortal';
import { useCasinoFilterState } from 'components/Pages/Casino/CasinoFilterContext';
import {
  casinoFilterTypeMap,
  deleteMultipleCasinoFilters,
} from 'components/Pages/Casino/useCasinoFilter';

import MultiFilterList from './MultiFilterList';

const MultiFilter = ({ disabled = false, isCasinoNavigation }) => {
  const {
    providers: { data: providers },
  } = useCasinoNewState();
  const {
    filter: { providerNames },
    providerFilterActive,
    setProviderFilter,
    updateFilter,
  } = useCasinoFilterState();
  const searchProviderNames = getSearchParam(window.location.search, 'providerNames');

  // set initial active filter providerNames from search param on mount
  useEffect(() => {
    const filtersFromSearch = searchProviderNames?.split(',');
    if (filtersFromSearch?.length > 0) {
      updateFilter({ providerNames: filtersFromSearch });
    }
  }, []);

  const toggleProviderFilterActive = useCallback(() => {
    setProviderFilter(!providerFilterActive);
  }, [providerFilterActive]);

  const onCancel = useCallback(() => {
    updateFilter({ providerNames: [] });
    deleteMultipleCasinoFilters([
      casinoFilterTypeMap.providerNames,
      casinoFilterTypeMap.gameTypeNames,
    ]);
  }, []);

  return (
    <>
      {!isCasinoNavigation && (
        <ChipsItem
          active={providerNames.length > 0}
          disable={disabled}
          icon="filter"
          onClick={toggleProviderFilterActive}
        />
      )}

      {providerFilterActive && (
        <ModalPortal>
          <DefaultPopup
            className="casino-filter-popup"
            headerTitle="casino_filters"
            onClose={toggleProviderFilterActive}
          >
            <div className="popup__content">
              <div className="casino-filters-container">
                <MultiFilterList
                  filterField={casinoFilterTypeMap.providerNames}
                  filters={providers}
                  title="filter_by_provider"
                  translated
                />
              </div>
              <div className="sticky-bottom-buttons-container border absolute">
                <Button
                  className="button-disabled"
                  disabled={providerNames.length === 0}
                  label="cancel"
                  onClick={onCancel}
                  size="big"
                  type="secondary"
                />
                <Button
                  label="filter"
                  onClick={toggleProviderFilterActive}
                  size="big"
                  type="primary"
                />
              </div>
            </div>
          </DefaultPopup>
        </ModalPortal>
      )}
    </>
  );
};

export default MultiFilter;
